module.exports = __webpack_public_path__ + "assets/img/22@3x.160d7e9e.png";